import { acceptHMRUpdate, defineStore } from 'pinia'

import api from '@/lib/api'
import sorting from '@/lib/utils/sorting'

export const useCompanyStore = defineStore('company', {
  state: () => ({
    companies: [],
    isCompaniesLoaded: false,
  }),

  actions: {
    async getCompany() {
      if (this.isCompaniesLoaded) return
      const { data } = await api.user.getCompany()
      const companies =
        data.companies?.map((company) => ({
          ...company,
          name: `${company.name} (${company.uid})`,
        })) || []
      const sortedCompanies = sorting.sortObjectsListByAlphaAsc(companies, 'name')
      this.companies = sortedCompanies
      this.isCompaniesLoaded = true
    },

    resetState() {
      this.$reset()
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useCompanyStore, import.meta.hot))
}
